import React from 'react';
import { Body1, H4 } from '@xo-union/tk-ui-typography';
import styles from '../../themePicker.scss';

export const NoFilterResults = () => (
  <div className={styles.noResult}>
    <H4>No results</H4>
    <Body1 className={styles.noResultBody}>
      We're having trouble finding designs that match your search. Please update your filters and search again, or check
      out all of our themes below
    </Body1>
  </div>
);
